import { ethers } from 'ethers';
import { ACTIVE } from '../config/networks';

export function makeEthersProvider(injected) {
  // Wrap the injected EIP-1193 provider — ethers 5 pattern
  return new ethers.providers.Web3Provider(injected, 'any');
}

export function makeReadProvider() {
  return new ethers.providers.JsonRpcProvider(ACTIVE.rpcUrls[0]);
}

export function toUnits(amount) {
  // USDT on BSC / opBNB = 18 decimals per contract spec
  return ethers.utils.parseUnits(String(amount || '0'), 18);
}

export function fromUnits(wei) {
  try { return ethers.utils.formatUnits(wei || 0, 18); } catch (_e) { return '0'; }
}
